const DefaultComponent = () => import('@/ui-overrides/default/pages/request/review/tab-order.vue');


export default {
	name: 'TabOrderWrapper',

	functional: true,

	render(h, context) {
		let component = DefaultComponent;

		const uiOverride = context.parent.$store.state.agency.default_ui;

		try {
			const override = require(`@/ui-overrides/${uiOverride}/pages/request/review/tab-order.vue`);
			component = override.default;
		}
		catch (err) {
			context.parent.$log.debug(`No override found: ${err}`);
		}

		return h(
			component,
			context.data,
			context.children,
		);
	},
};
